import { useCallback, useContext } from 'react';

import {
  CHF_CLIENTS_FILTER,
  CHF_MAX_SERVICES_COST,
  CHF_MIN_SERVICES_COST,
} from '@app/pages/Clients/ClientsList/constants/filterKeysAndIds';
import { ClientFiltersContext } from '@app/providers';

import { RangeWithStartAndEnd } from '@pages/Clients/ClientsList/components/Filters';

export const ClientsSales = ({
  includedFiltersIndex,
  labelClassName,
}: {
  includedFiltersIndex: number;
  labelClassName: string;
}) => {
  const { filters, setFilters } = useContext(ClientFiltersContext);

  const handleChange = useCallback(
    (value: string | number | null, filterGroupKey: string): void => {
      const hasNumericValue = value || value === 0;

      setFilters({
        ...(filters || []),
        ClientsFilter: [
          ...(filters.ClientsFilter.filter(
            (_, index) => index !== includedFiltersIndex
          ) || []),
          {
            ...filters.ClientsFilter?.[includedFiltersIndex],
            Values: [
              {
                ...filters.ClientsFilter?.[includedFiltersIndex]?.Values?.[0],
                [filterGroupKey]: hasNumericValue ? +value : null,
              },
            ],
          },
        ],
      });
    },
    [filters, includedFiltersIndex, setFilters]
  );

  return (
    <RangeWithStartAndEnd
      labelClassName={labelClassName}
      minValue={
        filters.ClientsFilter?.[includedFiltersIndex]?.Values?.[0]
          ?.MinServicesCost
      }
      maxValue={
        filters.ClientsFilter?.[includedFiltersIndex]?.Values?.[0]
          ?.MaxServicesCost
      }
      min={0}
      max={250000000}
      filterGroupKey={CHF_CLIENTS_FILTER}
      filterUnitKey={CHF_MIN_SERVICES_COST}
      filterUnitMaxKey={CHF_MAX_SERVICES_COST}
      filterGroupIndex={includedFiltersIndex}
      handleMinChange={(value) => handleChange(value, 'MinServicesCost')}
      handleMaxChange={(value) => handleChange(value, 'MaxServicesCost')}
    />
  );
};
